import { BaseViewStore } from 'core/stores';
import { observable, action, makeObservable } from 'mobx';
import { sourceOfChange } from 'common/constants';
import FulfillmentOrderProcessingStore from './FulfillmentOrderProcessingStore';
import FulfillmentOrderStore from './FulfillmentOrderStore';
import { notificationError, translate } from 'core/utils';
import { BaasicDropdownViewStore } from 'common/stores';
import _ from 'lodash';

class NeverShippedViewStore extends BaseViewStore {
	@observable selectedVoidLabelOption = null;
	@observable disableSaveBtn = true;
	@observable voidOnChannel = false;
	neverShippedOptions = [
		{ value: 0, label: 'Move FO to Entered and increase inventory' },
		{ value: 1, label: 'Create new FO in Assigned with same tracking information' },
	];

	constructor(rootStore, { modalParams }) {
		super(rootStore);
		makeObservable(this);
		this.modalParams = modalParams;
		this.selectedItems = _.get(this.modalParams, 'data.selectedItems');
		this.selectedItem = _.get(this.modalParams, 'data.selectedItem');
		this.fulfillmentOrderStore = new FulfillmentOrderStore(rootStore);
		this.neverShippedDropdownStore = new BaasicDropdownViewStore({
			staticOptions: this.neverShippedOptions,
			value: this.neverShippedOptions[0],
		});
	}

	@action.bound
	markNeverShipped = async () => {
		const notificationId = this.rootStore.notificationStore.load(translate('BULKNOTIFICATION.NEVERSHIPPED'));
		this.modalParams.close();
		try {
			const fulfillmentOrderProcessingStore = new FulfillmentOrderProcessingStore(this.rootStore);
			if (this.selectedItems) {
				const fulfillmentOrderIds = _.map(this.selectedItems, item => {
					return item.id;
				});
				const response = await fulfillmentOrderProcessingStore.neverShippedBulk(
					{
						fulfillmentOrderIds: fulfillmentOrderIds,
						voidLabelOnChannel: this.voidOnChannel,
						createNewFulfillmentOrder: this.neverShippedDropdownStore.value.value,
					},
					sourceOfChange.neverShipped
				);

				if (response.successful > 0) {
					if (response.failed == 0) {
						this.rootStore.notificationStore.success(['ORDERVIEW.NEVERSHIPPEDBULKSUCCESS']);
					} else if (response.failed > 0) {
						this.rootStore.notificationStore.warning([
							'ORDERVIEW.NEVERSHIPPEDBULKPARTIALSUCCESS',
							{ successful: response.successful, failed: response.failed },
						]);
					}
				}
			} else {
				const neverShippedParams = {
					fulfillmentOrderId: this.selectedItem.id,
					voidLabelOnChannel: this.voidOnChannel,
					createNewFulfillmentOrder: this.neverShippedDropdownStore.value.value,
				};
				const response = await fulfillmentOrderProcessingStore.neverShipped(
					neverShippedParams,
					sourceOfChange.neverShipped
				);
				if (response.successful > 0) {
					this.rootStore.notificationStore.success([
						'ORDERVIEW.NEVERSHIPPEDSUCCES',
						{ id: this.selectedItem.fulfillmentOrderId },
					]);
				}
			}
		} catch (err) {
			notificationError({ store: this.rootStore.notificationStore, err });
		}
		this.rootStore.notificationStore.dismiss(notificationId);
		this.modalParams.success();
	};
}

export default NeverShippedViewStore;
